<template>

  <div class="app-container">

    <el-card class="mb20 mt20 ml20 mr20 ta-l" v-show="showSearch" ref="searchBox">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="Ukey序列号" prop="ukeySn">
          <el-input
              v-model="queryParams.ukeySn"
              placeholder="请输入Ukey序列号"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="信用代码" prop="kqOrgCode">
          <el-input
              v-model="queryParams.kqOrgCode"
              placeholder="请输入刻企信用代码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="手机号码" prop="telephone">
          <el-input
              v-model="queryParams.telephone"
              placeholder="请输入手机号码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div class="button-box flex-center-end" ref="buttonBox">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd('add')">新增授权</el-button>
        <right-toolbar :showSearch.sync="showSearch" @queryTable="handleQuery"
                       storageKey="xxxxxxxx" @getColumns="getColumns"></right-toolbar>
      </div>
      <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :height="getDynamicStyles(showSearch)">
        <el-table-column
            prop="ukeySn"
            align="center"
            label="Ukey序列号">
          <template slot-scope="scope">
            <el-link @click="copyText(scope.row.ukeySn)">
              <div class="text-container">{{ scope.row.ukeySn }}</div>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="licKey"
            align="center"
            label="应用密钥">
          <template slot-scope="scope">
            <el-link @click="copyText(scope.row.licKey)">
              <div class="text-container">{{ scope.row.licKey }}</div>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="licData"
            align="center"
            label="应用授权">
          <template slot-scope="scope">
            <el-link @click="copyText(scope.row.licData)">
              <div class="text-container">{{ scope.row.licData }}</div>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="notAfter"
            align="center"
            label="授权有效期">
        </el-table-column>
        <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120">
          <template slot-scope="scope">
            <el-popconfirm
                class="ml10"
                v-if="$moment(scope.row.notAfter).diff($moment(), 'days') <= 30 || orgCode === '91210204341167191F'"
                @confirm="handleAdd('edit' , scope.row.ukeySn)"
                :title="'到期时间 ：' + scope.row.notAfter + '是否延期?'"
            >
              <el-button size="mini" type="text" slot="reference">延 期</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <authorization-add
        v-if="visible"
        :visible.sync="visible"
        :type.sync="type"
        :uKeySn="uKeySn"
        @getApplyAuthInfo="getApplyAuthInfo"
    />

  </div>

</template>

<script>
import AuthorizationAdd from "@/pages/customerEnterprise/components/authorizationAdd.vue";
import Cookie from "js-cookie";
import {getDynamicStyles} from "@/utils/ruoyi";

export default {
  name: "authorization",
  components: {AuthorizationAdd},
  data() {
    return {
      loading: true,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      tableKey: 0,
      showSearch: true,
      tableData: [],
      visible: false,
      type: '',
      uKeySn: '',
      orgCode: ''
    }
  },
  created() {
    this.orgCode = Cookie.get('orgCode')
    this.getApplyAuthInfo()
  },
  methods: {
    getDynamicStyles,
    getColumns(e) {
      this.tableKey += 1
      this.$set(this, 'columns', e)
    },
    handleAdd(type, uKeySn) {
      this.type = type
      this.uKeySn = uKeySn
      this.visible = true
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      } catch (err) {
        console.error('复制失败', err);
      }
    },
    getApplyAuthInfo() {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.getApplyAuthInfo, this.queryParams).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.loading = false;
        } else {
          this.$message.error(res.data.msg);
          this.loading = false
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getApplyAuthInfo()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
      },
          this.handleQuery();
    },
  }
}
</script>

<style scoped lang="less">
.text-container {
  max-width: 200px; /* 或者其他需要的宽度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
